import { Component, OnInit } from '@angular/core';
import { SignUpService } from '../_services/sign-up.service';
import { FormGroup, Validators, FormBuilder, ValidationErrors, AbstractControl, ValidatorFn, FormGroupDirective, NgForm, FormControl } from '@angular/forms';
import { SignUp } from '../_models/sign-up';
import swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { ErrorStateMatcher } from '@angular/material';
import * as crypto from 'crypto-js';
import { ValidationErrorMessage } from '../constants/validation';
import { WhiteSpaceValidators } from '../shared/white-space-validator';
import { Router } from '../../../node_modules/@angular/router';
import { SnotifyService, SnotifyPosition } from '../../../node_modules/ng-snotify';



export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (isSubmitted));
  }
}


@Component({
  
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  signUpFormGroup: FormGroup;
  signUpDataForm: SignUp = new SignUp();

  constructor(private signUpService:SignUpService,
    private formbuilder: FormBuilder,
    private router:Router,
    private snotifyService:SnotifyService,
  ) { }

  ngOnInit() {
    this.signUpFormValidate();
  }


  signUpFormValidate() {
    const mobnumPattern = "^[0-9+]*$";
    const namePattern = "^[A-Za-z\\s-]+$";
    const emailPattern = "[[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";

    this.signUpFormGroup = this.formbuilder.group({
      firstName: ['', [Validators.required, Validators.pattern(namePattern)]],
      lastName: ['',  [Validators.required, Validators.pattern(namePattern)]],
      email: ['', [Validators.required, Validators.pattern(emailPattern)]],

      password: ['', Validators.required],
      mobileNum: ['', [Validators.required, Validators.pattern(mobnumPattern), WhiteSpaceValidators.emptySpace()]],
      confirmPassword: ['', [Validators.required, this.compareValidator('password')]]
    });

  }
  compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }
      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }
      return controlToCompare && controlToCompare.value !== c.value ? { 'compare': true } : null;
    };
  }
  matcher = new MyErrorStateMatcher();
  /*---Error Message for name---*/
getErrorMsgForAddFeedbackFormfirstName() {
  return this.signUpFormGroup.controls.firstName.errors.required ? ValidationErrorMessage.REQUIRED :
      this.signUpFormGroup.controls.firstName.errors.pattern ? ValidationErrorMessage.ALPHABET :
          '';
}
/*---Error Message for name---*/
getErrorMsgForAddFeedbackFormlastName() {
  return this.signUpFormGroup.controls.lastName.errors.required ? ValidationErrorMessage.REQUIRED :
      this.signUpFormGroup.controls.lastName.errors.pattern ? ValidationErrorMessage.ALPHABET :
          '';
}
  /*---Error Message for eMail---*/
  getErrorMsgForAddFeedbackFormEmail() {
    return this.signUpFormGroup.controls.email.errors.required ? ValidationErrorMessage.REQUIRED :
      this.signUpFormGroup.controls.email.errors.pattern ? ValidationErrorMessage.VALID_EMAIL :
          '';
  }
 /*---Error Message for mobileNo---*/
getErrorMsgForAddFeedbackMobileNumber() {
  return this.signUpFormGroup.controls.mobileNum.errors.required ? ValidationErrorMessage.REQUIRED :
    this.signUpFormGroup.controls.mobileNum.errors.pattern ? ValidationErrorMessage.VALID_MOBILE :
      this.signUpFormGroup.controls.mobileNum.errors.whitespace ? ValidationErrorMessage.REQUIRED :
      this.signUpFormGroup.controls.mobileNum.errors.minlength ? ValidationErrorMessage.VALID_MOBILE :
      this.signUpFormGroup.controls.mobileNum.errors.maxlength ? ValidationErrorMessage.VALID_MOBILE :



        '';

}
  /*---Error Message for Password---*/
getErrorMsgForPassword() {
  return this.signUpFormGroup.controls.password.errors.required ? ValidationErrorMessage.REQUIRED :
   this.signUpFormGroup.controls.password.errors.minlength ? ValidationErrorMessage.MIN_LENGTH_FOUR :
   this.signUpFormGroup.controls.password.errors.maxlength ? ValidationErrorMessage.MAX_LENGTH_TWENTY :
    this.signUpFormGroup.controls.password.errors.whitespace ? ValidationErrorMessage.REQUIRED :
      '';
}
getErrorMsgForLoginFormconfirmPassword() {
  return this.signUpFormGroup.controls.confirmPassword.errors.required ? ValidationErrorMessage.REQUIRED : '';
}

    

onSubmit(){


  if (this.signUpFormGroup.valid) {
    this.signUpDataForm.firstName = this.signUpFormGroup.get('firstName').value;
    this.signUpDataForm.lastName = this.signUpFormGroup.get('lastName').value;
    this.signUpDataForm.email = this.signUpFormGroup.get('email').value;
    this.signUpDataForm.hashPassword = btoa(this.signUpFormGroup.get('password').value);
    this.signUpDataForm.mobileNum = this.signUpFormGroup.get('mobileNum').value;
    console.log("Sign UP Data form"+this.signUpDataForm.hashPassword);
    this.signUpService.signUp(this.signUpDataForm).subscribe(resp=>{
      if(resp.status===200){
        if(resp.status==200){
          console.log("calling")
          let msg="User Created successfully";
          let action=''
          this.snotifyService.success(msg, action, {
            timeout:3000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            position:SnotifyPosition.rightBottom
          })
          this.router.navigateByUrl('/login');
        
        }
      }
       
  } ,(error: any) => {
    //this.loading = false;
    if (error.status === 401){
     // window.alert("User Id Already Exists")
       let msg = "Email Id Already Exists"
       let action = ''
       this.snotifyService.error(msg, action, {
         timeout: 3000,
         showProgressBar: true,
         closeOnClick: true,
         pauseOnHover: true,
         position: SnotifyPosition.rightBottom
      })
    }
  })
      
}

}


}
